<app-page class="width-100" pageTitle="History">
  <div class="history-page">
    <div class="header rounded-sm">
      <div class="header-item">Date</div>
      <div class="header-item">PROJ</div>
      <div class="header-item">IMAX</div>
    </div>
    @if (historyData$ | async; as historyData) {
    <div class="body rounded-sm" [style.height]="getBodyHeight()">
      @if (historyData.isLoading && !historyData.response) {
      <div class="loading">
        <app-loading />
      </div>
      } @else if(historyData.response) {
      <app-table
        class="width-100"
        [data]="historyData.response.history"
        (onHistorySave)="updateHistory($event)"
        (onRefreshHistory)="refreshHistoryRecord($event)"
      />
      }
    </div>
    <app-refresh
      class="width-100"
      [refreshing]="historyData.isLoading"
      (refresh)="refreshData()"
      [lastUpdatedText]="historyApiService.lastUpdatedText()"
    />
    }
  </div>
</app-page>
